export const CONTACT_US_ANALYTICS_EVENT = 'contact-us:analytics';
export const CONTACT_US_MANAGE_CONSENT_EVENT = 'contact-us:manage-consent';
export const CONTACT_US_CONFIG_PATH =
  '/chats/chat-brain/contact-admin/configuration';
// Match only the leading AEM author prefix; capture the raw origin (1) and locale (2).
// Leave the suffix untouched to preserve query encoding and fragments.
export const CONTACT_AUTHOR_PATH_PATTERN =
  /^((?:https?:)?\/\/[^/?#]+)?\/content\/sapdx\/countries\/([^/?#]+)\//i;
export const CONTACT_US_API_HOSTS = {
  nonProd: 'https://api-qa.services.sap.com',
  prod: 'https://api2.services.sap.com',
};
export const CHAT_CONSENT_COOKIE = {
  LEVEL: 1,
  DOMAIN: 'cai.tools.sap',
};
export const SURVEY_CHAT_URL_BASE =
  'https://cc-c1sccp1035467.cc.sinch.com/ecf/latest/communicationpanel/index.jsp';

export const REGIONAL_LOCALES = new Set([
  'ru_ru',
  'ar_sa',
  'en_sa',
  'en_sg',
  'fr_be',
  'nl_be',
  'es_co',
  'en_za',
  'el_gr',
  'en_au',
  'fr_fr',
  'sr_rs',
]);

// Private UDEx markup shared with the contract test.
export const UDEX_FOOTER_TAG = 'udex-footer';
export const UDEX_FOOTER_CONTACT_SELECTOR = '.udex-footer__contact-social';
